export var FilterFieldDataType;
(function (FilterFieldDataType) {
    FilterFieldDataType["DATE"] = "DATE";
    FilterFieldDataType["NUMBER"] = "NUMBER";
    FilterFieldDataType["STRING"] = "STRING";
    FilterFieldDataType["BOOLEAN"] = "BOOLEAN";
})(FilterFieldDataType || (FilterFieldDataType = {}));
export var FQLFieldOperator;
(function (FQLFieldOperator) {
    FQLFieldOperator["PRESENT"] = "PRESENT";
    FQLFieldOperator["NOT_PRESENT"] = "NOT_PRESENT";
    FQLFieldOperator["EQ"] = "EQ";
    FQLFieldOperator["EXACTLY_MATCHES"] = "EXACTLY_MATCHES";
    FQLFieldOperator["NOT_EXACTLY_MATCHES"] = "NOT_EXACTLY_MATCHES";
    FQLFieldOperator["LT"] = "LT";
    FQLFieldOperator["GT"] = "GT";
    FQLFieldOperator["BEFORE"] = "BEFORE";
    FQLFieldOperator["AFTER"] = "AFTER";
    FQLFieldOperator["CONTAINS"] = "CONTAINS";
    FQLFieldOperator["NOT_CONTAINS"] = "NOT_CONTAINS";
    FQLFieldOperator["BETWEEN"] = "BETWEEN";
    FQLFieldOperator["IN"] = "IN";
    FQLFieldOperator["NOT_IN"] = "NOT_IN";
    FQLFieldOperator["IS_RELATIVE_DATE"] = "IS_RELATIVE_DATE";
    FQLFieldOperator["IS_RELATIVE_DATE_GT"] = "IS_RELATIVE_DATE_GT";
    FQLFieldOperator["IS_RELATIVE_DATE_LT"] = "IS_RELATIVE_DATE_LT";
})(FQLFieldOperator || (FQLFieldOperator = {}));
export const NoOperandOps = [FQLFieldOperator.PRESENT, FQLFieldOperator.NOT_PRESENT];
export const oneOperandOps = [
    FQLFieldOperator.EQ,
    FQLFieldOperator.LT,
    FQLFieldOperator.GT,
    FQLFieldOperator.BEFORE,
    FQLFieldOperator.AFTER,
    FQLFieldOperator.IS_RELATIVE_DATE,
];
export const twoOperandOps = [
    FQLFieldOperator.BETWEEN,
    FQLFieldOperator.IS_RELATIVE_DATE_LT,
    FQLFieldOperator.IS_RELATIVE_DATE_GT,
];
export const nOperandOps = [
    FQLFieldOperator.IN,
    FQLFieldOperator.NOT_IN,
    FQLFieldOperator.CONTAINS,
    FQLFieldOperator.NOT_CONTAINS,
    FQLFieldOperator.EXACTLY_MATCHES,
    FQLFieldOperator.NOT_EXACTLY_MATCHES,
];
export const FQLFieldOperatorLabel = {
    [FQLFieldOperator.PRESENT]: 'is present',
    [FQLFieldOperator.NOT_PRESENT]: 'is not present',
    [FQLFieldOperator.EQ]: 'is equal to',
    [FQLFieldOperator.EXACTLY_MATCHES]: 'exactly matches',
    [FQLFieldOperator.NOT_EXACTLY_MATCHES]: 'does not exactly match',
    [FQLFieldOperator.LT]: 'is less than',
    [FQLFieldOperator.GT]: 'is greater than',
    [FQLFieldOperator.BEFORE]: 'is before',
    [FQLFieldOperator.AFTER]: 'is after',
    [FQLFieldOperator.CONTAINS]: 'contains',
    [FQLFieldOperator.NOT_CONTAINS]: "doesn't contain",
    [FQLFieldOperator.BETWEEN]: 'is between',
    [FQLFieldOperator.IN]: 'is any of',
    [FQLFieldOperator.NOT_IN]: 'is none of',
    [FQLFieldOperator.IS_RELATIVE_DATE]: 'is',
    [FQLFieldOperator.IS_RELATIVE_DATE_LT]: 'is less than',
    [FQLFieldOperator.IS_RELATIVE_DATE_GT]: 'is more than',
};
export var FieldFilterConfigGroup;
(function (FieldFilterConfigGroup) {
    FieldFilterConfigGroup["CONTACT"] = "CONTACT";
    FieldFilterConfigGroup["PROPERTY"] = "PROPERTY";
})(FieldFilterConfigGroup || (FieldFilterConfigGroup = {}));
